import { IsiDtoPlSuggestResponse, AvailableScreenList, IsiCallerType } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlSuggest";
import { bPropTr } from "../../form.ts";
import { modifWaitStatus } from "../../IsiPage.ts";
import { iws_event, iws_preventDefault, iws_stopPropagation } from "../../tools.ts";
import { ControlTypes } from "../Form/Controls/IsiControlTypes";
import { IsiPlSuggest } from "../PresentationLogic/IsiPlSuggest";

const FIELD_SEPARATOR = "@";
declare function iCtFs(sNameCtrl: string, sFocusableCtrlID: string);
declare function ValidatorEnable(validator2: any, arg1: boolean);
declare function isiPostBack(eventTarget: string, eventArgument: any);

//Enum : Donne les types de sources connexes.
export enum IsiDataSourceType {
    SCREEN = 0,
    SQL = 1,
    CODE = 2
};
window.IsiDataSourceType = IsiDataSourceType;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CLEM
'- Date        : 10/05/2016
'- Description : Fonction appelée sur le clique du bouton propriété d'un connexe.
'-----------------------------------------------------------------------------------------*/
function connexeCtrlImgProp(sNameCtrl: string, sFocusableCtrlID: string, doWait: boolean, sValue: string, continueTreatment: boolean, evt: any): boolean {
    let canExec = doWait;
    if (typeof (continueTreatment) == "undefined") {
        continueTreatment = true;
    }

    if (typeof (sValue) == "undefined") {
        sValue = sNameCtrl;
    }

    if (continueTreatment) {

        const ihdCtrlNameClick = (document.getElementById("ihdCtrlNameClick") as HTMLInputElement);
        if (ihdCtrlNameClick) {
            ihdCtrlNameClick.value = sValue;
        }

        // On indique quel menu a afficher lorsqu'on clique sur un controle       
        iCtFs(sNameCtrl, sFocusableCtrlID);

        // On desactive les validator avant de faire la fleche verte sinon ca plante
        if (typeof (Page_Validators) !== 'undefined') {
            if (Page_Validators !== 'undefined' && Page_Validators !== null) {
                for (var i = 0; i < Page_Validators.length; i++) {
                    var validator2 = Page_Validators[i];
                    ValidatorEnable(validator2, false);
                }
            }
        }

        if (isiApp.dtoClientIWS.confirmLostModifTimeOut) {
            uiCore.log("timeout:" + isiApp.dtoClientIWS.confirmLostModifTimeOut);
            // On annule popin de création d'enregistrement
            window.clearTimeout(isiApp.dtoClientIWS.confirmLostModifTimeOut);

            isiApp.dtoClientIWS.confirmLostModifTimeOut = null;
        } else {
            uiCore.log("pas de timeOut pour le confirmLostModifTimeOut");
        }

        // fonction surchargeable apres click sur fleche verte ou lien bleu
        canExec = BlockConnexePostBack(sNameCtrl, evt, doWait);
    }
    return canExec;
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : YLAR
'- Date        : 11/04/2022
'- Description : Fonction gérant les bloquages du repostage causé par un controle connexe. 
'-----------------------------------------------------------------------------------------*/
function BlockConnexePostBack(sNameCtrl: string, evt: any, doWait: boolean) {
    let canExec = screenCore.beforeDoPostBackOnBlueLinkOrGreenArrow(sNameCtrl);

    // fonction surchargeable apres click sur fleche verte ou lien bleu
    if (canExec) {
        if (doWait) {
            // On affiche le statut d'attente
            modifWaitStatus(true, true, LOADING);
        }
        uiCore.flushClientState();
    } else {
        iws_stopPropagation(evt);
    }

    if (typeof isiApp != "undefined") {
        isiApp.uploadState();
    }
    return canExec;
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CLEM
'- Date        : 10/05/2016
'- Description : Fonction appelée sur le clique du bouton recherche d'un connexe.
'-----------------------------------------------------------------------------------------*/
export function connexeCtrlImgSearch(sNameCtrl: string, sFocusableCtrlID: string, event: any, imgButtonID: string): boolean {
    var evt = iws_event(event);

    if (sNameCtrl) {
        //GELA 2007.05.29 Gestion des sous-controles
        //on recupere d'abord le controle
        const oCtrl = iwsAllCtrls.getCtrl(sNameCtrl.split(FIELD_SEPARATOR)[0]);

        // YLAR 12/08/11YLAR 12/08/11 DYSF 0000043968 : correction de la recherche sur une VT le remplacement des _ provoquait une erreur, si le nom du control connexe contient des _, on ne reussit pas a recharger en VB le controle
        var sValue = sNameCtrl;

        // Variable pour vérifier que l'utilisateur n'a pas cancel l'event.
        var continueTreatment = true;

        if (oCtrl && (oCtrl.ctrlType === ControlTypes.CTRL_ISICOMBOCRITERE || oCtrl.ctrlType === ControlTypes.CTRL_ISITEXTCONNEXE || oCtrl.ctrlType === ControlTypes.CTRL_ROISITEXTCONNEXE) && sNameCtrl.search("@SEARCH=") != -1) {
            var sCnxSearch = "";

            // On appel checkForConnexeSearchAvailability avec un callback dans le cas ou on a une popin
            checkForConnexeSearchAvailability(oCtrl, IsiCallerType.GreenArrow, (result) => {
                sCnxSearch = result;
                if (afterSearchClick(oCtrl, sCnxSearch, sNameCtrl, sFocusableCtrlID, sValue, evt, continueTreatment)) {
                    envoyerRecherche(sNameCtrl, imgButtonID);
                }
            }).then((result: string) => {
                sCnxSearch = result;
                if (isiApp.dtoClientIWS.confirmLostModifTimeOut) {
                    uiCore.log("timeout:" + isiApp.dtoClientIWS.confirmLostModifTimeOut);
                    // On annule popin de création d'enregistrement
                    window.clearTimeout(isiApp.dtoClientIWS.confirmLostModifTimeOut);

                    isiApp.dtoClientIWS.confirmLostModifTimeOut = null;
                } else {
                    uiCore.log("pas de timeOut pour le confirmLostModifTimeOut");
                }

                // Si submit est TRUE alors on a pas eu de POPIN
                // TABO 24/12/2016 - PB0016387 : la recherche par loup doit etre active apres un message bloquant. 
                if (uiCore.getSubmit() || sCnxSearch != "") {
                    if (afterSearchClick(oCtrl, sCnxSearch, sNameCtrl, sFocusableCtrlID, sValue, evt, continueTreatment)) {
                        envoyerRecherche(sNameCtrl, imgButtonID);
                    }
                }
            })
        }
    }

    // On retourne false pour bloquer le repostage, on appelle isiPostBack lorsque l'on veut vraiment reposter.
    return false;
}

/**
 * ouvre la VT de recherche
 */
function envoyerRecherche(nameCtrl, imgButtonID) {
    const propertyTb = uiCore.componentManager.getComponent<any>("controlToolbar");
    if (propertyTb) { // en mode Touch, le bouton recherche est dans un cmoposant
        propertyTb.launchSearch(iwsAllCtrls.getCtrl(nameCtrl.split("@")[0]));
    } else { // en mode desktop, le bouton recherche est dans le connexe
        isiPostBack(imgButtonID, null);
    }
}
/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : MAXB
'- Date        : 25/01/2017
'- Description : Fonction appelée sur le clique du bouton propriété d'un connexe.
'-----------------------------------------------------------------------------------------*/
export async function iws_ConnexePropertyImgClick(sNameCtrl: string, sFocusableCtrlID: string, evt, sIDObjTxt: string, sIDObj: string, imgButtonID: string, sValue: string, continueTreatment: boolean): Promise<boolean> {
    let bSubmit: boolean;
    const result = await bPropTr(evt, sIDObjTxt, sIDObj, imgButtonID);
    bSubmit = result && connexeCtrlImgProp(sNameCtrl, sFocusableCtrlID, bSubmit, sValue, continueTreatment, evt);
    if (bSubmit) {
        const propertyTb = uiCore.componentManager.getComponent<any>("controlToolbar");
        if (propertyTb) { // en mode Touch, le bouton propriété est dans un cmoposant
            propertyTb.launchProperty(iwsAllCtrls.getCtrl(sIDObj));
        } else { // en mode desktop, le bouton propriété est dans le connexe
            isiPostBack(imgButtonID, null);
        }
    };
    return false;
}

/*
 * Recherche les ecrans listes disponibles pour le controle donne.
 */
export function searchAvailableScreenList(ctrl: IwsControle, callerType): Promise<IsiDtoPlSuggestResponse> {
    return new Promise((resolve, reject) => {
        const plSuggest = new IsiPlSuggest()
        plSuggest.GetAvailableScreenList(ctrl.id, callerType, ctrl.mainCtrlId).then((suggRes) => {
            resolve(suggRes);
        }).catch((ex) => {
            uiCore.logError("Error in AJAX (HTML controls update)", ex);
            resolve(IsiDtoPlSuggestResponse.fromJS({
                screenListAvailable: AvailableScreenList.NOTDEFINED
            }));
        });
    });
}
/// <summary>
///  Recherche la disponibilite de la recherche connexe. C'est a dire la disponibilite de l'ecran
///  liste du controle.
/// </summary>
/// <history>
/// 	[LBRI]	29/07/2009	Created
/// </history>
// CLEM - 118252 - GLOB032 - Choix d'une instance
function checkForConnexeSearchAvailability(ctrl: IwsControle, callerType: any, callbackTreatment: any): Promise<string> {
    return new Promise((resolve, reject) => {

        // LBRI - 2009.10.12 - [DYSF:31881] : on ne fait le teste que pour les TextConnexes (pas les combos).
        if (ctrl.ctrlType != ControlTypes.CTRL_ISICOMBOCRITERE
            && ctrl.ctrlType != ControlTypes.CTRL_ISITEXTCONNEXE
            && ctrl.ctrlType != ControlTypes.CTRL_ROISITEXTCONNEXE) {
            return "";
        }

        if (ctrl.dataSourceType !== IsiDataSourceType.SCREEN) {
            return "";
        }

        if (typeof (ctrl.callerType) != "undefined") {
            if (ctrl.callerType != callerType) {
                ctrl.screenListAvailable = AvailableScreenList.NOTDEFINED;
            }
        }
        ctrl.callerType = callerType;

        if (ctrl.screenListAvailable === AvailableScreenList.NONE) {
            // s'il n'y a aucun ecran disponible, on le notifie a l'utilisateur.
            displayNoScreenMessage();
        } else if (ctrl.screenListAvailable === AvailableScreenList.ONE) {
            // s'il n'y a qu'un ecran disponible, on l'utilise
            resolve(ctrl.screenList);
        } else if (ctrl.screenListAvailable === AvailableScreenList.NOTDEFINED) {
            // si la propriete n'a pas encore ete determinee, on le fait maintenant
            searchAvailableScreenList(ctrl, callerType).then((res: IsiDtoPlSuggestResponse) => {
                if (res.screenListAvailable === AvailableScreenList.ONE) {
                    ctrl.screenList = res.screenList;
                    ctrl.screenListAvailable = AvailableScreenList.ONE;
                    resolve(res.screenList);
                } else if (res.screenListAvailable === AvailableScreenList.NONE) {
                    ctrl.screenListAvailable = AvailableScreenList.NONE;
                    ctrl.screenList = "";
                    displayNoScreenMessage();
                    resolve(ctrl.screenList);
                } else if (res.screenListAvailable === AvailableScreenList.SEVERAL) {
                    ctrl.screenList = res.screenList;
                    ctrl.screenListAvailable = AvailableScreenList.SEVERAL;
                    // CLEM - 118252 - GLOB032 - Choix d'une instance PopIn
                    uiCore.setSubmit(false);
                    return displaySeveralChoicesToUser(ctrl, callerType, callbackTreatment);
                } else if (res.screenListAvailable === AvailableScreenList.NoneButSuggestNotUseProfilRights) {
                    // JBUI - 08/10/2012 - DYSF.52268 : S'il n'y a aucun ecran disponible, 
                    // mais que l'on ne doit pas tenir compte des droits du profil pour le suggest,
                    // on affiche le message a l'utilisateur sans desactiver le suggest.
                    displayNoScreenMessage();
                    resolve("");
                } else {
                    displayNoScreenMessage();
                    resolve("");
                }
            });

        } else if (ctrl.screenListAvailable === AvailableScreenList.SEVERAL) {
            // si le controle n'a pas encore determine son ecran liste, on est oblige de le faire
            if (!ctrl.screenList) {
                searchAvailableScreenList(ctrl, callerType).then((res: IsiDtoPlSuggestResponse) => {
                    ctrl.screenList = res.screenList;
                });
            }
            // CLEM - 118252 - GLOB032 - Choix d'une instance PopIn
            uiCore.setSubmit(false);
            // s'il y a plusieurs ecrans, on va les proposer a l'utilisateur afin qu'il en choisisse un.
            // TODO à migrer
            return displaySeveralChoicesToUser(ctrl, callerType, callbackTreatment);
        }
    })
}
/*
 *  Affiche une pop-up a l'utilisateur pour lui demander quel ecran liste choisir.
 */
function displaySeveralChoicesToUser(ctrl, callerType, callbackTreatment): Promise<string> {
    return new Promise((resolve, reject) => {
        // comme il existe plusieurs ecrans listes possibles, on drop Suggest
        ctrl.dropSuggestAndSearch(true, false);
        getInstanceForSearch(ctrl.screenList, "GetAvailableInstance", ctrl.id, callerType, callbackTreatment);
        resolve("");
    })
}

function getInstanceForSearch(sIDObj, sTraitement, sIDCtrl, callerType, callbackTreatment) {
    uiCore.addUITreatment({
        func: "getInstanceForAll",
        args: [sIDObj, sTraitement, "SEARCH", sIDCtrl, callerType, callbackTreatment]
    });
}

function displayNoScreenMessage() {
    /// <summary>
    ///  Affiche un message a l'utilisateur pour lui specifier qu'il n'a droit a aucun ecran.
    /// </summary>
    /// <history>
    /// 	[LBRI]	30/07/2009	Created
    /// </history>
    uiCore.showErrorMessage(uiCore.getMessage("ErrDroit", "PasDroit").IsiLabel);
}

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CLEM
'- Date        : 10/05/2016
'- Description : Méthode récupérant l ecran de destination dans le callback de la popin ou sans popin
'-----------------------------------------------------------------------------------------*/
function afterSearchClick(oCtrl: IwsControle, sCnxSearch: string, sNameCtrl: string, sFocusableCtrlID: string, sValue: string, evt: any, continueTreatment: boolean): boolean {

    if (sCnxSearch === "" || sCnxSearch === "CANCEL_BY_USER") {
        if (sCnxSearch === "") {
            // on drop le bouton Search
            oCtrl.dropSuggestAndSearch(false, true);
        }

        iws_stopPropagation(evt);
        iws_preventDefault(evt);
        // Si on stop le traitement
        continueTreatment = false;
        // YLAR 20/02/2019 DYSF80013 : Ajout d'une ligne d'historique dans le cas de l'annulation de la sélection d'instance
        history.pushState(null, null, document.URL);
    } else {
        sValue += FIELD_SEPARATOR + "SCREENLIST=" + sCnxSearch;
        // Si on tout c'est bien passé
        continueTreatment = true;
    }
    // On appel le même traitement que sur le bouton property car on fait la meme chose
    connexeCtrlImgProp(sNameCtrl, sFocusableCtrlID, true, sValue, continueTreatment, null);

    return continueTreatment;
}

/*
 * Recherche la disponibilite de la recherche connexe. C'est a dire la disponibilite de l'ecran
 *   liste du controle.
 */
export function suggConnexeSearchAvailability(ctrl: IwsControle, callerType: IsiCallerType): Promise<string> {
    return new Promise((resolve, reject) => {
        var res;
        // LBRI - 2009.10.12 - [DYSF:31881] : on ne fait le teste que pour les TextConnexes (pas les combos).
        if (ctrl.ctrlType !== ControlTypes.CTRL_ISICOMBOCRITERE
            && ctrl.ctrlType !== ControlTypes.CTRL_ISITEXTCONNEXE
            && ctrl.ctrlType !== ControlTypes.CTRL_ROISITEXTCONNEXE) {
            return "";
        }

        if (ctrl.dataSourceType !== IsiDataSourceType.SCREEN) {
            return "";
        }

        if (typeof (ctrl.callerType) !== "undefined") {
            if (ctrl.callerType != callerType) {
                ctrl.screenListAvailable = AvailableScreenList.NOTDEFINED;
            }
        }
        ctrl.callerType = callerType;

        // Dysf83087 - Lorsqu on fait * dans un connexe, on ne veut pas du message vous n'avez pas les droits
        if (ctrl.screenListAvailable === AvailableScreenList.NOTDEFINED) {
            // si la propriete n'a pas encore ete determinee, on le fait maintenant
            searchAvailableScreenList(ctrl, callerType).then((res) => {
                ctrl.screenList = res.screenList;
                ctrl.screenListAvailable = res.screenListAvailable;

                if (typeof (ctrl.screenList) === "undefined") {
                    ctrl.screenList = "";
                }
                resolve(ctrl.screenList);
            });
        }

    });
}

/*-- CREATION -------------------------------------------------------------------
'- Auteur      : DREN
'- Date        : ???
'- Description : Méthode masquant la zone non modifiable utilisée pour affichée la partie droite du texte
'- Modification [MAXB]  28/02/2020 PB0020281 - Correction faille de sécurité XSS pour DivAlignRight dans les controles connexe
'-------------------------------------------------------------------------------*/

export function iws_IsiSuggestUpdateShownValue(inputId: string, checkIfHasFocus: boolean) {
    const input = jQuery('#' + inputId);
    const inputParent = input.parent();

    if (inputParent.hasClass("alignRightValue")) {
        const shownValue = inputParent.children(".shownValue");
        // Reprise de la valeur et du tooltip du champ
        const temp = document.createElement('div');
        temp.textContent = input.val().toString();
        shownValue.html("<span tp='1'>" + temp.innerHTML + "</span>");
        shownValue.attr("isititle", input.attr("isititle"));
        if (!checkIfHasFocus || !inputParent.hasClass("iActiveFocus")) {
            inputParent.addClass("alignRightValueVisible");
        }
    }
}
